export default "/static/output/images/open-graph-tradera-default.72cbcd71.png";